// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  width: 98%;
  background-color: #2563EB;
  color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 10;
  padding-top: 5px;
  padding-bottom: 5px;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 1rem;
  padding-right: 1rem;
  border-radius: 5px;
  margin: 10px 10px 0 10px;
	height: 80px;
}
.navbar-x {
  width: 98%;
  background-color: red;
  color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 10;
  padding-top: 5px;
  padding-bottom: 5px;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 1rem;
  padding-right: 1rem;
  border-radius: 5px;
  margin: 10px 10px 0 10px;
	height: 80px;
}
.flex-column 	{	display: flex;  flex-direction: column; align-items: center;  justify-content: center;	flex-grow: 0; }
.flex-row 		{	display: flex;  flex-direction: row;  	align-items: center;  justify-content: center;	flex-grow: 0;	}

.menu-button {
  padding: 4px 12px;
  background-color: #3b82f6; /* bg-blue-500 */
  color: white;
  border-radius: 4px;
  transition: background-color 0.3s;
  font-size: 12px;
  text-align: center;
}

.menu-button:hover {
  background-color: #2563eb; /* hover:bg-blue-600 */
}

.menu-button.active {
  background-color: #22c55e; /* bg-green-500 */
}

.menu-icon {
  margin-left: 10px;
  padding: 4px;
  background-color: transparent;
  color: white;
  border-radius: 4px;
  transition: background-color 0.3s;
  font-size: 36px;
  text-align: center;
  cursor:pointer;
}
.menu-icon:hover {
  background-color: #3b82f6; /* hover:bg-blue-600 */
}

.menu-icon.active {
  background-color: #22c55e; /* bg-green-500 */
}



@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

/* Menu collapsed state */
.vd-wside--collapsed {
  width: 60px !important;
}

.vd-wside--collapsed .vd-wnav__txt {
  display: none;
}

.vd-wside--collapsed .vd-wgrp__label {
  display: none;
}

.vd-wside--collapsed .vd-wnav {
  justify-content: center;
  padding: 8px;
}

.vd-wside--collapsed .vd-wnav__ico {
  margin: 0;
}

.vd-wside--admin {
 border-left: 8px solid #ff4d4d;
}

/* Window app container */
.vd-wapp {
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  background: #F1F5F9;
  color: #15212B;
  overflow: hidden;
}

/* Login mode - not fixed, takes only sidebar width */
.vd-wapp--login {
  position: relative;
  height: 100vh;
  width: 260px;
}

/* Menu main content area */
.vd-wmain {
  flex: 1 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.vd-wmain > .vd-panel {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Menu navigation button - override for specific width/height */
.vd-wnav {
  width: 233px !important;
  height: 40px !important;
}

.vd-wnav__bar {
  position: absolute;
  left: -14px;
  top: 9px;
  bottom: 9px;
  width: 3px;
  border-radius: 0 3px 3px 0;
  background: #1C6BB0;
}

/* Record pill button */
.recpill {
  min-height: 52px;
  padding: 10px 18px 10px 14px;
  border: none;
  border-radius: 11px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #1C6BB0;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  box-shadow: 0 2px 8px rgba(28, 107, 176, 0.28);
  transition: all 0.15s;
  white-space: nowrap;
}

.recpill:not(.recpill--on):hover {
  background: #155489;
}

.recpill--on {
  background: #DB5B57;
  box-shadow: 0 2px 10px rgba(219, 91, 87, 0.35);
}

.recpill.recpill--on:hover {
  background: #DB5B57;
}

.recpill__icon {
  display: flex;
}

.recpill__ring {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2.5px solid #fff;
}

.recpill__rec {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  animation: pulse 1.1s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.45; transform: scale(0.8); }
}

/* CKEditor toolbar - based on !design, fixed to bottom in editor view */
.ck-toolbar {
  padding: 15px 30px;
  border-top: 1px solid #E4EAF0;
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 288px;
  right: 0;
  z-index: 1000;
}

/* CKEditor editable styles - based on !design */
.ck-editor__editable {
  width: 100%;
  max-width: 820px;
  background: #fff;
  border: 1px solid #E4EAF0;
  border-radius: 12px;
  padding: 34px 44px;
  box-shadow: 0 4px 18px rgba(21, 84, 137, .05);
  height: auto;
  min-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
  margin: 0 auto;
  box-sizing: border-box;
}

.ev .ck-editor__editable {
  min-height: 0;
}

.ck-button {
  min-width: 38px;
  height: 38px;
  padding: 0 10px;
  border: 1px solid transparent;
  border-radius: 9px;
  background: transparent;
  color: #5C6E7D;
  cursor: pointer;
  font-family: inherit;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1px;
  transition: all .12s;
}

.ck-button:hover {
  background: #EAF2F9;
  color: #155489;
}

.ck-button.ck-on {
  background: #EAF2F9;
  color: #155489;
  border-color: #B7D3EA;
}

.ck-button .ck-icon {
  width: 16px;
  height: 16px;
}

/* Custom COPY button style */
.fmt--primary {
  background: #1C6BB0;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  padding: 0 18px;
  gap: 8px;
  box-shadow: 0 2px 7px rgba(28, 107, 176, .25);
  min-width: 38px;
  height: 38px;
  border: 1px solid transparent;
  border-radius: 9px;
  cursor: pointer;
  font-family: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all .12s;
}

.fmt--primary:hover {
  background: #155489;
  color: #fff;
}

.fmt--primary:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  box-shadow: none;
  pointer-events: none;
}

/* Toast notification */
.wtoast {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 11px 18px;
  background: #15212B;
  color: #fff;
  border-radius: 11px;
  font-size: 13.5px;
  font-weight: 500;
  box-shadow: 0 10px 30px rgba(0, 0, 0, .25);
  z-index: 9999;
  animation: toastin .2s ease;
}

@keyframes toastin {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Menu.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,wCAAwC;EACxC,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;CACzB,YAAY;AACb;AACA;EACE,UAAU;EACV,qBAAqB;EACrB,YAAY;EACZ,wCAAwC;EACxC,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;CACzB,YAAY;AACb;AACA,gBAAgB,aAAa,GAAG,sBAAsB,EAAE,mBAAmB,GAAG,uBAAuB,EAAE,YAAY,EAAE;AACrH,cAAc,aAAa,GAAG,mBAAmB,IAAI,mBAAmB,GAAG,uBAAuB,EAAE,YAAY,EAAE;;AAElH;EACE,iBAAiB;EACjB,yBAAyB,EAAE,gBAAgB;EAC3C,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB,EAAE,sBAAsB;AACnD;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;AAC9C;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,yBAAyB,EAAE,sBAAsB;AACnD;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;AAC9C;;;;AAIA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA,yBAAyB;AACzB;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,qDAAqD;AACrD;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,gEAAgE;AAChE;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,UAAU;EACV,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,8CAA8C;EAC9C,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,WAAW,UAAU,EAAE,mBAAmB,EAAE;EAC5C,MAAM,aAAa,EAAE,qBAAqB,EAAE;AAC9C;;AAEA,wEAAwE;AACxE;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,WAAW;EACX,QAAQ;EACR,aAAa;AACf;;AAEA,gDAAgD;AAChD;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;EAC7C,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,QAAQ;EACR,6CAA6C;EAC7C,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,2CAA2C;EAC7C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF","sourcesContent":[".navbar {\n  width: 98%;\n  background-color: #2563EB;\n  color: white;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  z-index: 10;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  border-radius: 5px;\n  margin: 10px 10px 0 10px;\n\theight: 80px;\n}\n.navbar-x {\n  width: 98%;\n  background-color: red;\n  color: white;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  z-index: 10;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  border-radius: 5px;\n  margin: 10px 10px 0 10px;\n\theight: 80px;\n}\n.flex-column \t{\tdisplay: flex;  flex-direction: column; align-items: center;  justify-content: center;\tflex-grow: 0; }\n.flex-row \t\t{\tdisplay: flex;  flex-direction: row;  \talign-items: center;  justify-content: center;\tflex-grow: 0;\t}\n\n.menu-button {\n  padding: 4px 12px;\n  background-color: #3b82f6; /* bg-blue-500 */\n  color: white;\n  border-radius: 4px;\n  transition: background-color 0.3s;\n  font-size: 12px;\n  text-align: center;\n}\n\n.menu-button:hover {\n  background-color: #2563eb; /* hover:bg-blue-600 */\n}\n\n.menu-button.active {\n  background-color: #22c55e; /* bg-green-500 */\n}\n\n.menu-icon {\n  margin-left: 10px;\n  padding: 4px;\n  background-color: transparent;\n  color: white;\n  border-radius: 4px;\n  transition: background-color 0.3s;\n  font-size: 36px;\n  text-align: center;\n  cursor:pointer;\n}\n.menu-icon:hover {\n  background-color: #3b82f6; /* hover:bg-blue-600 */\n}\n\n.menu-icon.active {\n  background-color: #22c55e; /* bg-green-500 */\n}\n\n\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n/* Menu collapsed state */\n.vd-wside--collapsed {\n  width: 60px !important;\n}\n\n.vd-wside--collapsed .vd-wnav__txt {\n  display: none;\n}\n\n.vd-wside--collapsed .vd-wgrp__label {\n  display: none;\n}\n\n.vd-wside--collapsed .vd-wnav {\n  justify-content: center;\n  padding: 8px;\n}\n\n.vd-wside--collapsed .vd-wnav__ico {\n  margin: 0;\n}\n\n.vd-wside--admin {\n border-left: 8px solid #ff4d4d;\n}\n\n/* Window app container */\n.vd-wapp {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  background: #F1F5F9;\n  color: #15212B;\n  overflow: hidden;\n}\n\n/* Login mode - not fixed, takes only sidebar width */\n.vd-wapp--login {\n  position: relative;\n  height: 100vh;\n  width: 260px;\n}\n\n/* Menu main content area */\n.vd-wmain {\n  flex: 1;\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.vd-wmain > .vd-panel {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* Menu navigation button - override for specific width/height */\n.vd-wnav {\n  width: 233px !important;\n  height: 40px !important;\n}\n\n.vd-wnav__bar {\n  position: absolute;\n  left: -14px;\n  top: 9px;\n  bottom: 9px;\n  width: 3px;\n  border-radius: 0 3px 3px 0;\n  background: #1C6BB0;\n}\n\n/* Record pill button */\n.recpill {\n  min-height: 52px;\n  padding: 10px 18px 10px 14px;\n  border: none;\n  border-radius: 11px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: #1C6BB0;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  font-family: inherit;\n  box-shadow: 0 2px 8px rgba(28, 107, 176, 0.28);\n  transition: all 0.15s;\n  white-space: nowrap;\n}\n\n.recpill:not(.recpill--on):hover {\n  background: #155489;\n}\n\n.recpill--on {\n  background: #DB5B57;\n  box-shadow: 0 2px 10px rgba(219, 91, 87, 0.35);\n}\n\n.recpill.recpill--on:hover {\n  background: #DB5B57;\n}\n\n.recpill__icon {\n  display: flex;\n}\n\n.recpill__ring {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 2.5px solid #fff;\n}\n\n.recpill__rec {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background: #fff;\n  animation: pulse 1.1s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; transform: scale(1); }\n  50% { opacity: 0.45; transform: scale(0.8); }\n}\n\n/* CKEditor toolbar - based on !design, fixed to bottom in editor view */\n.ck-toolbar {\n  padding: 15px 30px;\n  border-top: 1px solid #E4EAF0;\n  background: #fff;\n  position: fixed;\n  bottom: 0;\n  left: 288px;\n  right: 0;\n  z-index: 1000;\n}\n\n/* CKEditor editable styles - based on !design */\n.ck-editor__editable {\n  width: 100%;\n  max-width: 820px;\n  background: #fff;\n  border: 1px solid #E4EAF0;\n  border-radius: 12px;\n  padding: 34px 44px;\n  box-shadow: 0 4px 18px rgba(21, 84, 137, .05);\n  height: auto;\n  min-height: 200px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  margin: 0 auto;\n  box-sizing: border-box;\n}\n\n.ev .ck-editor__editable {\n  min-height: 0;\n}\n\n.ck-button {\n  min-width: 38px;\n  height: 38px;\n  padding: 0 10px;\n  border: 1px solid transparent;\n  border-radius: 9px;\n  background: transparent;\n  color: #5C6E7D;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1px;\n  transition: all .12s;\n}\n\n.ck-button:hover {\n  background: #EAF2F9;\n  color: #155489;\n}\n\n.ck-button.ck-on {\n  background: #EAF2F9;\n  color: #155489;\n  border-color: #B7D3EA;\n}\n\n.ck-button .ck-icon {\n  width: 16px;\n  height: 16px;\n}\n\n/* Custom COPY button style */\n.fmt--primary {\n  background: #1C6BB0;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 0 18px;\n  gap: 8px;\n  box-shadow: 0 2px 7px rgba(28, 107, 176, .25);\n  min-width: 38px;\n  height: 38px;\n  border: 1px solid transparent;\n  border-radius: 9px;\n  cursor: pointer;\n  font-family: inherit;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all .12s;\n}\n\n.fmt--primary:hover {\n  background: #155489;\n  color: #fff;\n}\n\n.fmt--primary:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  box-shadow: none;\n  pointer-events: none;\n}\n\n/* Toast notification */\n.wtoast {\n  position: fixed;\n  bottom: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  padding: 11px 18px;\n  background: #15212B;\n  color: #fff;\n  border-radius: 11px;\n  font-size: 13.5px;\n  font-weight: 500;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, .25);\n  z-index: 9999;\n  animation: toastin .2s ease;\n}\n\n@keyframes toastin {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
